<template>
  <div class="list-tab">
    <div class="member-korean__nav">
      <div v-for="(item, index) in yearList" :key="'korNav' + index" :class="['nav-item', {on: item.selected}]" @click="changeConsonant(item)">
        {{ item.name }}
      </div>
    </div>
    <div class="magazine-list">
      <div v-for="(item, index) in list" :key="'magazine' + index" class="magazine-item" @click="goDetail(item.id)">
        <img :src="item.imgPath" alt="magazine" width="222" height="290" class="magazine-item__img" />
        <div class="magazine-item__title is-14m">{{ item.title }}</div>
      </div>
    </div>
    <pagination :total-count="listSearchInfo.totalCount" :now-page="listSearchInfo.page" :limit="listSearchInfo.limit" @changePage="listChangePage" />
  </div>
</template>

<script>
import {useMagazineStore} from '~/store/magazine'
import Pagination from '~/components/common/Pagination.vue'

export default {
  name: 'Tab3',
  components: {Pagination},
  setup() {
    const store = useMagazineStore()
    return {store}
  },
  props: {
    menu: {
      type: Number,
      default: ''
    }
  },
  data() {
    return {
      yearCounter: 0,
      list: [
        {
          id: 0,
          yearMonth: '',
          title: '',
          imgPath: '',
          hasPreviewFiles: 0,
          createdAt: '',
          updatedAt: '',
          isDeleted: 0
        }
      ],
      yearList: [
        {
          name: '',
          selected: false
        }
      ],
      listSearchInfo: {
        limit: 12,
        totalCount: 0,
        page: 1,
        year: ''
      }
    }
  },
  mounted() {
    this.getMagazineMonthlyList()
  },
  methods: {
    listChangePage(page) {
      this.listSearchInfo.page = page
      this.getMagazineMonthlyList()

      // scroll top 부드럽게
      window.scrollTo({top: 0, behavior: 'smooth'})
    },
    // 연도별 목록 조회
    changeConsonant(item) {
      this.listSearchInfo.year = item.name
      item.selected = true
      // 나머지 아이템은 다 False
      this.yearList.forEach(navItem => {
        if (navItem.name !== item.name) {
          navItem.selected = false
        }
      })
      if (item.name === '전체') this.listSearchInfo.year = ''
      this.listSearchInfo.page = 1
      this.getMagazineMonthlyList()
    },
    async getMagazineMonthlyList() {
      try {
        const {data} = await this.store.getMagazineMonthlyList(this.listSearchInfo)
        this.list = data.list
        this.listSearchInfo.totalCount = data.count
        if (this.yearCounter === 0) {
          this.yearList = data.yearList
          this.yearCounter++
        }
      } catch (error) {
        console.log(error)
        alert('오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
      }
    },
    goDetail(id) {
      this.$router.push(`/magazine/${id}`)
    }
  }
}
</script>

<style scoped lang="scss">
.list-tab {
  .member-korean__nav {
    display: flex;
    border-bottom: 1px solid #dbdbdb;
    flex-wrap: wrap;
    margin-bottom: 24px;
    .nav-item {
      width: 71px;
      height: 42px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #606060;
      position: relative;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      cursor: pointer;
      &:hover {
        color: #0058aa;
      }
      &.on {
        color: #0058aa;
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          display: block;
          width: 100%;
          height: 3px;
          background: #0058aa;
        }
      }
    }
  }
  .magazine-list {
    display: flex;
    gap: 24px;
    flex-wrap: wrap;
    margin-bottom: 35px;
    .magazine-item {
      width: 222px;
      cursor: pointer;
    }
    .magazine-item__img {
      width: 222px;
      height: 290px;
    }
    .magazine-item__title {
      padding: 16px;
      border-bottom: 1px solid #dbdbdb;
    }
  }
}
</style>
